export default "__VITE_ASSET__y_uzaRyN__"